/**
 * Mixin enforces instant of validator per vue component. Automatic installation of $validator is disabled by
 * VeeValidation configuration in CLIENT_SOURCE/validation/index.js
 */
export default {
  $_veeValidate: {
    validator: 'new' // give me a new validator each time.
  }
}



// WEBPACK FOOTER //
// ./client/components/validationMixin.js